import React, { useEffect, useState } from 'react';
import styled from '@emotion/styled';
import Header from './components/Header';
import SearchSection from './components/SearchSection';
import DataTable from './components/DataTable';
import Pagination from './components/Pagination';
import { getUser } from 'Utils/storage';
import { useDispatch, useSelector } from 'react-redux';
import { GET_TRANSPORTERS_LIST, GET_VEHICLE_TYPES, GET_VEHICLE_REGNUMBER_DETAILS, GET_TTBIL_ROUTE_CODE_DETAILS, UPLOAD_TRANSPORTATION_MANAGEMENT_DATA, GET_TRANSPORTATION_MANAGEMENT_DATA, GET_PRICING_BASIS, DOWNLOAD_TRANSPORTATION_MANAGEMENT_DATA, DELETE_TRANSPORTATION_MANAGEMENT_DATA, POST_TRANSPORTATION_MANAGEMENT_DATA, UPDATE_TRANSPORTATION_MANAGEMENT_DATA, GET_PO_DROPDOWN_LISTS, TOAST_ERROR } from 'Constants/actionConstants';
import Moment from 'moment';
import ActionLoader from 'Components/ActionLoader/index';
import Sticky from 'Components/Sticky/index';
import ConfirmationPopup from './components/ConfirmationPopup';

const Container = styled.div`
  padding: 20px;
  background: #F4F6FF;
  height: calc(100vh - 100px);
`;

const TransportationManagement = () => {
  const itemsPerPage = 10;
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [isAdding, setIsAdding] = useState(false);
  const [newRecord, setNewRecord] = useState({
    provider_id: '',
    provider_name: '',
    vehicle_type: '',
    vehicle_type_id: '',
    vehicle_reg_no: '',
    route_code: '',
    fixed_cost: '',
    excluded_route_code: '',
    included_route_code: '',
    billing_parameter_name: '',
    billing_parameter_id: '',
    trip_count: '',
    freight_rate: '',
    contract_tenure_from: null,
    contract_tenure_to: null,
    contract_type_name: "",
    contract_type_id: ''
  });
  const [missingFields, setMissingFields] = useState([]);
  const [search, setSearch] = useState('');
  const [data, setData] = useState([]);
  const [vehicleNumberDetails, setVehicleNumberDetails] = useState([]);
  const [routeCodesDetails, setRouteCodesDetails] = useState([]);
  const [providerId, setProviderId] = useState('');
  const [vehicleTypeId, setVehicleTypeId] = useState('');
  const [totalCount, setTotalCount] = useState(0);
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [showConfirm, setShowConfirm] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const user = getUser();

  const dispatch = useDispatch();
  const { transportersList, vehicleTypes, pricingBasis } = useSelector(state => state.constants);
  const { loaderT1 } = useSelector(state => state.common);
  const { poDropdownLists } = useSelector(state => state.PODetails);

  useEffect(() => {
    getTransportersList();
    getVehicleTypes();
    getPricingPasis();
    getDropdowns();
  }, []);

  useEffect(() => {
  const handler = setTimeout(() => {
    setDebouncedSearch(search);
  }, 500); // debounce delay in milliseconds

  return () => {
    clearTimeout(handler);
  };
}, [search]);


  const getDropdowns = () => {
    dispatch({
      type: GET_PO_DROPDOWN_LISTS
    })
  }

  const getTransportersList = () => {
    dispatch({
      type: GET_TRANSPORTERS_LIST,
      params: {
        companyId: user.companyId,
        branchId: user.branchId,
        type: 2,
        isMultimode: false
      }
    })
  }

  const getVehicleTypes = () => {
    dispatch({
      type: GET_VEHICLE_TYPES,
      params: {
        companyId: user.companyId,
        branchId: user.branchId
      }
    })
  }

  const handleAdd = () => {
    setNewRecord({
      provider_id: '',
      provider_name: '',
      vehicle_type: '',
      vehicle_type_id: '',
      vehicle_reg_no: '',
      route_code: '',
      fixed_cost: '',
      excluded_route_code: '',
      included_route_code: '',
      billing_parameter_name: '',
      billing_parameter_id: '',
      trip_count: '',
      freight_rate: '',
      contract_tenure_from: null,
      contract_tenure_to: null,
      contract_type_name: "",
      contract_type_id: ''
    });
    setIsAdding(true);
  };

  const handleNewRecordChange = (field, value) => {
    setNewRecord(prev => ({
      ...prev,
      [['provider', 'billing_parameter', 'contract_type'].includes(field) ? `${field}_name` : field]: typeof value === 'object' && value !== null ? (value.name || (['route_code', 'excluded_route_code', 'included_route_code'].includes(field) ? value['sap_code'] : value[field]) || value.value) : ((['fixed_cost', 'trip_count', 'freight_rate'].includes(field) && value) ? +value : value),
      ...(typeof value === 'object' && value !== null && {
        [`${field}_id`]: value.id || value.value
      }),
      ...(typeof value === 'object' && value !== null &&  ['route_code', 'excluded_route_code', 'included_route_code'].includes(field) && {
        [`${field}_selected`]: true
      })
    }));
    if(field === 'vehicle_reg_no' && typeof value !== 'object') {
      getVehicleNumberDetails(value);
    }
    if(['route_code', 'excluded_route_code', 'included_route_code'].includes(field) && typeof value !== 'object') {
      getTTBilRouteCodeDetails(value);
    }
  };

  const handleDateChange = ({ startDate, endDate }) => {
    setNewRecord(prev => ({
      ...prev,
      contract_tenure_from: startDate && Moment(startDate).valueOf(),
      contract_tenure_to: endDate && Moment(endDate).valueOf()
    }));
  };

  const handleSaveNewRecord = () => {
    const dedicatedRequiredFields = [
      'provider_id', 'route_code', 'fixed_cost', 'contract_type_id',
      'billing_parameter_id', 'freight_rate', 'contract_tenure_from', 'contract_tenure_to'
    ];

    const nonDedicatedRequiredFields = [
      'provider_id', 'vehicle_type_id', 'route_code', 'contract_type_id',
      'billing_parameter_id', 'trip_count', 'freight_rate', 'contract_tenure_from', 'contract_tenure_to'
    ];
    const emptyFields = (newRecord.contract_type_id === 1 ? dedicatedRequiredFields : nonDedicatedRequiredFields).filter(field => !newRecord[field]);
    if (emptyFields.length > 0) {
      setMissingFields(emptyFields);
      return;
    }
    if(!newRecord['route_code_selected'] && ((newRecord['excluded_route_code'] && !newRecord['excluded_route_code_selected']) || (newRecord['included_route_code'] && !newRecord['included_route_code_selected']))) {
      dispatch({
        type: TOAST_ERROR,
        message: 'Please select a route code',
      })
      return;
    }
    ['route_code_selected', 'excluded_route_code_selected', 'included_route_code_selected'].forEach(field => {  
      delete newRecord[field];
    });
    setMissingFields([]);
    const onSuccess = () => {
      setIsAdding(false);
      setNewRecord({});
      getTransportationManagementDetails();
    }
    dispatch({
      type: POST_TRANSPORTATION_MANAGEMENT_DATA,
      data: {
        ...newRecord,
        company_id: user.companyId,
        user_name: user.adminName
      },
      onSuccess
    })
  };

  const handleCancelAdd = () => {
    setIsAdding(false);
    setNewRecord({});
  };

  const confirmDelete = (id) => {
  setDeleteId(id);
  setShowConfirm(true);
};

const handleDelete = () => {
  if (!deleteId) return;
  dispatch({
    type: DELETE_TRANSPORTATION_MANAGEMENT_DATA,
    data: { id: deleteId, userName: user.adminName },
    onSuccess: () => {
      getTransportationManagementDetails();
      setShowConfirm(false);
      setDeleteId(null);
    },
  });
};


  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const getVehicleNumberDetails = (vehicleNumber) => {
    const onSuccess = (resData) => {
      setVehicleNumberDetails(resData);
    }
    dispatch({
      type: GET_VEHICLE_REGNUMBER_DETAILS,
      params: {
        search: vehicleNumber,
        limit: 10,
        offset: currentPage - 1
      },
      onSuccess
    })
  }

  const getTTBilRouteCodeDetails = (routeCodes) => {
    const onSuccess = (resData) => {
      console.log("resData:", resData);
      setRouteCodesDetails(resData);
    }
    dispatch({
      type: GET_TTBIL_ROUTE_CODE_DETAILS,
      params: {
        search: routeCodes,
        limit: 10,
        offset: 0
      },
      onSuccess
    })
  }

  const handleUpload = (file) => {
    const onSuccess = (resData) => {
      getTransportationManagementDetails();
    }
    const formData = new FormData();
    formData.append("file", file);
    dispatch({
      type: UPLOAD_TRANSPORTATION_MANAGEMENT_DATA,
      payload: formData,
      params: {
        userName: user.adminName
      },
      onSuccess
    })
  } 

  useEffect(() => {
    getTransportationManagementDetails();
  }, [debouncedSearch, currentPage, providerId, vehicleTypeId]);

  const getTransportationManagementDetails = () => {
    const onSuccess = (data) => {
      setData(data.list || []);
      setTotalCount(data.documentCount)
    }
    const params = {
      limit: itemsPerPage,
      offset: (currentPage - 1) * itemsPerPage
    }
    if (debouncedSearch) {
      params.search = debouncedSearch;
    }

    if(providerId) {
      params.providerId = providerId;
    }
    if(vehicleTypeId) {
      params.vehicleTypeId = vehicleTypeId;
    }

    dispatch({
      type: GET_TRANSPORTATION_MANAGEMENT_DATA,
      params,
      onSuccess
    })
  }

  const getPricingPasis = () => {
    dispatch({
      type: GET_PRICING_BASIS,
      data: {
        rfqType: 1,
        companyId: user.companyId,
        branchId: user.companyId
      }
    })
  }

  const onClickDownload = (type) => {
    dispatch({
      type: DOWNLOAD_TRANSPORTATION_MANAGEMENT_DATA,
      params: {
        type,
        user_name: user.adminName
      }
    })
  }

  const updateEditedData = (updatedData) => {
    const onSuccess = () => {
      getTransportationManagementDetails();
    }
    const oldData = data.find((record) => record.transport_management_id === updatedData.transport_management_id);
    let oldDataAddition = {...updatedData};
    if(oldData){
      oldDataAddition['old_document'] = oldData;
    }
    dispatch({
      type: UPDATE_TRANSPORTATION_MANAGEMENT_DATA,
      data: {
        ...oldDataAddition,
        user_name: user.adminName
      },
      onSuccess
    })
  }

  const handleSearch = (search) => {
    setSearch(search);
    setCurrentPage(1);
  }

  const handleProviderChange = (option) => {
    setProviderId(option && option.id || '');
    setCurrentPage(1);
  }

  const handleVehicleTypeChange = (option) => {
    setVehicleTypeId(option && option.value || '');
    setCurrentPage(1);
  }

  const totalPages = Math.ceil(totalCount / itemsPerPage);
  // const startIndex = (currentPage - 1) * itemsPerPage;
  // const endIndex = startIndex + itemsPerPage;
  // const currentData = data.slice(startIndex, endIndex);

  return (
    <Sticky>
    <Container>
      {!!loaderT1 && <ActionLoader fixed={true}/>}
      <Header title="Transportation Management" />
      <SearchSection 
        onAdd={handleAdd} 
        onUpload={handleUpload} 
        onClickDownload={onClickDownload} 
        onSearch={handleSearch} 
        search={search} 
        providerId={providerId}
        vehicleTypeId={vehicleTypeId}
        handleProviderChange={handleProviderChange}
        handleVehicleTypeChange={handleVehicleTypeChange}
        transportersList={transportersList}
        vehicleTypes={vehicleTypes}
      />
      <DataTable 
        data={data}
        isAdding={isAdding}
        newRecord={newRecord}
        onNewRecordChange={handleNewRecordChange}
        onDateChange={handleDateChange}
        onSaveNewRecord={handleSaveNewRecord}
        onCancelAdd={handleCancelAdd}
        onDelete={confirmDelete}
        transportersList={transportersList}
        vehicleTypes={vehicleTypes}
        vehicleNumberDetails={vehicleNumberDetails}
        getVehicleNumberDetails={getVehicleNumberDetails}
        routeCodesDetails={routeCodesDetails}
        pricingBasis={pricingBasis}
        getTTBilRouteCodeDetails={getTTBilRouteCodeDetails}
        onEdit={updateEditedData}
        poDropdownLists={poDropdownLists}
        missingFields={missingFields}
        currentPage={currentPage}
      />
      <Pagination 
        currentPage={currentPage}
        totalPages={totalPages}
        totalItems={totalCount}
        itemsPerPage={itemsPerPage}
        onPageChange={handlePageChange}
      />
      <ConfirmationPopup
        open={showConfirm}
        title="Delete Confirmation"
        message="Are you sure you want to delete this entry?"
        confirmText="Yes, Delete"
        cancelText="Cancel"
        onConfirm={handleDelete}
        onCancel={() => setShowConfirm(false)}
      />

    </Container>
    </Sticky>
  );
};

export default TransportationManagement; 